import { USER_FIRST_TAB_PATH } from "../plugins/utils";

export const isActive = (pathname, path) => {
  if (!path) return;
  const HOME_ACTIVE = ["/", "/privacy", "/terms"];
  // console.log(pathname, path);
  switch (path) {
    case "/":
      return HOME_ACTIVE.includes(pathname);
    case "/wallet/recharge/recharge":
      return pathname.includes("/wallet");
    case "/user/bank-info":
    case USER_FIRST_TAB_PATH:
      return pathname.includes("/user");
    default:
      return pathname.includes(path);
  }
};
